import React from 'react';

import { StyledLoading } from './Loading.styled';
import { StyledSpinner } from './Spinner.styled';

const Loading = () => {
  return (
    <StyledLoading>
      <StyledSpinner />
    </StyledLoading>
  );
};

export default Loading;
